export class SharedConstants {
    public static REPORTING = 'Reporting';
    public static REPORTS = 'Reports';
    // public static ALOE_PROMOTIONS = '/ARGIplusAloe';
    public static ALOE_PROMOTIONS = '/Aloearoundtheworld';
    public static EVENT_PAGES = ['/Aloearoundtheworld','/foreverlive'];
    public static OVERVIEW = 'overview';
    public static BENELUX = 'benelux';
    public static FRANCE = 'france';
    public static GERMANY = 'germany';
    public static IRELAND = 'ireland';
    public static SCANDINAVIA = 'scandinavia';
    public static UK = 'uk';
    public static US = 'us';
    public static START_DATE = '2020-01-01';
    public static END_DATE = '2020-03-31';
    public static DEFAULT = 'default';
    public static GROUP_1 = 'Group 1';
    public static GROUP_2 = 'Group 2';
    public static GROUP_3 = 'Group 3';
    public static TOP_FBO = 'TopFBO';
    public static SOCIAL_CONTEST = 'SocialContest';
    public static LegacyUrlWhitelistPhrase = 'page/home-page';
    public static PREVIEW_BASE_URL = 'https://foreverliving.com';
    public static PREVIEW_BASE_DOMAIN = 'foreverliving.com';
    public static SHOP = 'shop';
    public static JOIN = 'join';
    public static CORPORATE = 'corporate';
    public static PREVIEW = 'preview';
    public static ACCOUNT = 'account';
    public static NEW_TAB = '_blank';
    public static MEMBER_DETAIL_PROPERTIES = 'Name,Email,FboID,MemberPreferences';
    public static LEGACY_JOIN_MOBILE_URL = 'https://m.foreverliving.com';
    public static LIVE_STREAM_URL = 'rallyEvent.livestreamURL';
}
